var map = {
	"./add-block.png": 88325,
	"./add.png": 28937,
	"./close-white.png": 83568,
	"./close.png": 35979,
	"./copy.png": 7213,
	"./email_icon.png": 1480,
	"./home.png": 68220,
	"./home_2.png": 59498,
	"./ico-left-arrow.png": 77968,
	"./icons_24pt_back.png": 77703,
	"./icons_24pt_back.svg": 88362,
	"./new-icon-left.png": 7638,
	"./personal_icon.png": 38615,
	"./phone.png": 18526,
	"./phone_icon.png": 94442,
	"./return.png": 4831,
	"./returnBook.png": 59478,
	"./return_round.png": 59782,
	"./share.png": 81217,
	"./white-arrow.png": 77232
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64075;